// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import dynamic from 'next/dynamic';
import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { InteractionProps } from 'react-json-view';
import { useState } from 'react';
const ReactJson = dynamic(() => import('react-json-view'), { ssr: false });
const CodeEditor = dynamic(() => import('components/CodeEditor'), { ssr: false });

// ----------------------------------------------------------------------

interface Props {
  name: string;
  label: string;
}

export default function RHFJSONEditor({ name, label, ...other }: Props) {
  const { control } = useFormContext();
  const [isChange, setIsChange] = useState<boolean>(false);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState: { error } }) => {
        const handleChange = (data: InteractionProps) => {
          field.onChange(data.updated_src);
        };

        if (isChange)
          return (
            <div>
              <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1}>
                <Typography variant="subtitle2">{label}</Typography>
                <FormControlLabel
                  label="Đổi công cụ sửa"
                  control={<Switch value={isChange} onChange={(_, value) => setIsChange(value)} />}
                />
              </Stack>
              <CodeEditor id={name} value={field.value} onChange={field.onChange} {...other} />
            </div>
          );
        return (
          <div>
            <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1}>
              <Typography variant="subtitle2">{label}</Typography>
              <FormControlLabel
                label="Đổi công cụ sửa"
                control={<Switch value={isChange} onChange={(_, value) => setIsChange(value)} />}
              />
            </Stack>
            <ReactJson
              name={name}
              theme="monokai"
              src={field.value}
              onEdit={handleChange}
              onAdd={handleChange}
              onDelete={handleChange}
              displayDataTypes={true}
              enableClipboard={false}
              {...other}
            />
          </div>
        );
      }}
    />
  );
}
